import { LanguageCode, LanguageCodes } from "../../i18n/LanguageCode";
import { LanguageInput } from "../input/LanguageInput";
import { UserAccountCreationInput, UserCreateAccountRequest } from "./UserCreateAccountRequest";
import { EmailPasswordInput, UserLoginRequest, UserLoginResponse } from "./UserLoginRequest";
import { EmailInput, UserSignUpRequest } from "./UserSignUpRequest";
import { UserLoginStatusRequest, UserLoginStatusResponse } from "./UserLoginStatusRequest";
import { UserLogoutRequest } from "./UserLogoutRequest";
import { UserRequestPasswordChangeRequest } from "./UserRequestPasswordChangeRequest";
import { UserChangePasswordRequest, EmailTokenPasswordInput } from "./UserChangePasswordRequest";
import { UserRequestDeleteRequest } from "./UserRequestDeleteRequest";
import { UserDeleteRequest } from "./UserDeleteRequest";
import { UserDataInput, UserDataRequest, UserDataResponse, UserDataType } from "./UserDataRequest";
import { PHPContext } from "../PHPContext";
import { PHPResponse } from "../PHPResponse";


export class PHPUser
{
  get language():LanguageCode
  {
    return LanguageCodes.en;
  }

  get phpContext():PHPContext
  {
    return null;
  }

  async signUp( email:string ):Promise<PHPResponse>
  {    
    let signUpRequest = new UserSignUpRequest();
    let input = new EmailInput();
    input.email = email;
    input.language = this.language;

    let response = await signUpRequest.request( this.phpContext, input );    

    return Promise.resolve( response );
  }

  async createAccount( tokenID:string, email:string, userName:string, password:string ):Promise<PHPResponse>
  {
    let accountCreationRequest = new UserCreateAccountRequest();

    let input = new UserAccountCreationInput();

    input.tokenID = tokenID;
    input.password = password;
    input.email = email;
    input.userName = userName;
    input.language = this.language;

    let response = await accountCreationRequest.request( this.phpContext, input );

    return Promise.resolve( response );
  }

  async login( email:string, password:string ):Promise<UserLoginResponse>
  {
    let loginRequest = new UserLoginRequest();

    let input = new EmailPasswordInput();

    input.email    = email;
    input.password = password;
    input.language = this.language;
    
    let response = await loginRequest.request( this.phpContext, input );

    return Promise.resolve( response );
  }

  static DEBUG_LOG = false;
  async loginStatus():Promise<UserLoginStatusResponse>
  {
    let loginRequest = new UserLoginStatusRequest();

    let input = new LanguageInput();

    input.language = this.language;
    
    let response = await loginRequest.request( this.phpContext, input, PHPUser.DEBUG_LOG );

    return Promise.resolve( response );
  }

  async logout():Promise<PHPResponse>
  {
    let logoutRequest = new UserLogoutRequest();

    let input = new LanguageInput();

    input.language = this.language;
    
    let response = await logoutRequest.request( this.phpContext, input );

    return Promise.resolve( response );
  }

  async requestPasswordChange( email:string ):Promise<PHPResponse>
  {
    let requestPasswordChangeRequest = new UserRequestPasswordChangeRequest();

    let input = new EmailInput();
    input.email = email;
    input.language = this.language;

    let response = await requestPasswordChangeRequest.request( this.phpContext, input );    

    return Promise.resolve( response );
  }

  async changePassword( token:string, email:string, password:string ):Promise<PHPResponse>
  {
    let changePasswordRequest = new UserChangePasswordRequest();

    let input = new EmailTokenPasswordInput();
    input.email = email;
    input.tokenID = token;
    input.password = password;

    input.language = this.language;

    let response = await changePasswordRequest.request( this.phpContext, input );    

    return Promise.resolve( response );
  }

  async requestDelete( email:string ):Promise<PHPResponse>
  {
    let requestDelete = new UserRequestDeleteRequest();

    let input = new EmailInput();
    input.email = email;
    input.language = this.language;

    let response = await requestDelete.request( this.phpContext, input );    

    return Promise.resolve( response );
  }

  async delete( tokenID:string, email:string, password:string ):Promise<PHPResponse>
  {
    let deleteRequest = new UserDeleteRequest();

    let input = new EmailTokenPasswordInput();

    input.email = email;
    input.tokenID = tokenID;
    input.password = password;
    input.language = this.language;

    let response = await deleteRequest.request( this.phpContext, input );    

    return Promise.resolve( response );
  }

  async getData( type:UserDataType ):Promise<UserDataResponse>
  {
    let dataRequest = new UserDataRequest();

    let input = new UserDataInput();

    input.type = type;
    input.language = this.language;

    let response = await dataRequest.request( this.phpContext, input );    

    return Promise.resolve( response );
  }
}